// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1gHAi","header":"MessagesList_header__1E8W3","chat":"MessagesList_chat__1zmRs"};